import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { CSSTransition } from 'react-transition-group'
import CSSModules from 'react-css-modules'

import Dropdown from 'components/dropdown/dropdown'
import SelectButton from './button/select_button'
import styles from './select.scss'

class Select extends PureComponent {

	constructor() {
		super()

		this.state = {
			isOpened: false,
			locked: false,
		}
	}

	elementClickHandler(option) {
		if (this.props.field) {
			this.props.onChange(option)
		}
		if (this.props.onChange) {
			this.props.onChange(option[this.props.key_name])
		}
		this.toggle()
	}

	toggle() {
		if (this.state.isOpened == true) {
			this.setState({ isOpened: false })
		} else {
			this.setState({ isOpened: true })
		}
	}

	doFocus() {
		if (this.state.locked || this.props.disabled) {
			return
		}
		this.setState({ isOpened: true})
	}

	doBlur() {
		if (this.state.isOpened) {
			this.setState({ isOpened: false, locked: true})
			setTimeout(() => {
				this.setState({locked: false})
			}, 250)
		}
	}

	doClick() {
		if (!this.state.isOpened) {
			document.activeElement.blur()
		}
	}

	getText(value) {
		// value !== 0 was added for cases like timer that need to treat the 0 as a valid value
		if (!value && value !== 0) {
			return this.props.placeholder
		}
		for (var i=0;i<this.props.options.length;i+=1) {
			if (this.props.options[i][this.props.key_name] === value) {
				return this.props.options[i][this.props.text_key]
			}
		}
		return this.props.placeholder
	}

	render() {
		return (
			<div name={this.props.name} styleName='select'>
				<SelectButton
					message={this.props.message}
					disabled={this.props.submitting || this.props.disabled}
					status={this.state.isOpened ? '' : this.props.status}
					active={this.state.isOpened}
					tabIndex={this.state.isOpened ? 0 : this.props.tabIndex}
					onFocus={this.doFocus.bind(this)}
					onClick={this.doClick.bind(this)}
					fontSize={this.props.fontSize}
					text={this.getText(this.props.value)}
				/>
				<div styleName='select_dropdown'>
					<CSSTransition
						in={this.state.isOpened}
						classNames={{
							enter: styles.enter,
							enterActive: styles['enter-active'],
							exit: styles.exit,
							exitActive: styles['exit-active'],
						}}
						timeout={300}
						unmountOnExit
					>
						<Dropdown
							tabIndex={this.state.isOpened ? this.props.tabIndex : 0}
							key_name = {this.props.key_name}
							text_key = {this.props.text_key}
							options={ this.props.options }
							onBlur = {this.doBlur.bind(this)}
							onElementClick={ this.elementClickHandler.bind(this) }
						/>
					</CSSTransition>
				</div>
			</div>
		)
	}
}

Select.propTypes = {
	options: PropTypes.array,
	onElementClick: PropTypes.func,
	fontSize: PropTypes.oneOf(['small', 'medium', 'big']),
}

Select.defaultProps = {
	key_name: 'value',
	text_key: 'text',
	disabled: false,
	tabIndex: 100,
}

export default CSSModules(Select, styles, {allowMultiple: true})
